<!--
 * @Author: DouDou
 * @LastEditors: 豆豆
 * @Date: 2020-09-17 11:18:28
 * @LastEditTime: 2020-11-05 14:27:35
 * @Description: File description
-->
<template>
  <div :class="['invitation', pageNotice ? 'invitation-notice' : '']">
    <!--  通知栏-跑马灯 -->
    <div class="invitation-notice-bar" v-if="pageNotice">
      <van-notice-bar mode="closeable" left-icon="volume-o"
        background="#fff5e0" color="#FE9B43" :text="pageNotice"
        @close="pageNotice=false"
      />
    </div>
    <!-- 规则展示按钮 -->
    <div class="invitation-btn-rule" @click="isShowRule = true"></div>
    <!-- 奖励明细 -->
    <div class="invitation-reward-statement">
      <div class="invitation-reward-sharecount">本月完成 <output>{{shareCountForGold}}/3</output></div>
      <img src="../assets/images/home-reward.png" alt="奖励清单">
    </div>
    <!-- 我的奖励 -->
    <div class="invitation-reward-myown">
      <div class="invitation-card-title">
        <i class="icon icon-gift"></i>
        <b>我的奖励</b>
        <span @click="go2RewardPage('查看明细')">查看明细 ></span>
      </div>
      <div class="invitation-reward-myown-count">
        <div class="invitation-reward-card-item" :class="{'link' : item.description === '兑换课程' || item.description === '礼品卡'}" v-for="(item, index) in rewardUnit" :key="index"
          @click="handleRewardClick(item)"
        >
          <div class="invitation-reward-card-item-con"><output>{{ item.dataNum || 0 }}</output> {{item.dataUnit || '元'}}</div>
          <p class="invitation-reward-card-item-des">{{item.description || '累计获得奖励'}}
            {{item.description === '兑换课程' ? ' >' : ''}}
            {{item.description === '礼品卡' ? ' >' : ''}}
          </p>
        </div>
      </div>
    </div>
    <!-- 底部邀请按钮 -->
    <div class="invitation-btn"  @click="showSharePanel()">
      <img src="../assets/images/sharepage-btn-invite.gif" alt="邀请好友拿奖励">
    </div>
    <!-- 底部邀请组件 -->
    <share-panel :class="isShowSharePanel ? 'invitation-sharePanel' : 'invitation-sharePanel-hidden'"
      :tutorId="tutorId"
      @shareSucc="handleShareSucc"
      @shareErr="handleShareErr"
      @shareClick="handleShareClick"
      @panelDisplay="handleSharePanelDisplay"
    />
    <div v-if="isShowSharePanel" @click="handleSharePanelDisplay(false)" class="invitation-sharePanel-bg"></div>
    <!-- 活动规则弹窗 -->
    <van-popup v-model="isShowRule" class="x-van-popup invitation-popup rule-popup">
      <div class="invitation-popup-close" @click="isShowRule = false"></div>
      <div class="invitation-popup-title">活动规则</div>
      <div class="invitation-popup-content" v-if="rule.content">
        <div class="rule-content-item" v-for="(item,index) in rule.content" :key="index">
          <h5>{{item.title}}</h5>
          <p v-for="(v,i) in item.content" :key="i" v-html="v"></p>
        </div>
      </div>
    </van-popup>
    <!-- 当前页面挽留弹窗 -->
    <van-popup v-model="isShowRetain2CurrPage" class="x-van-popup retain-popup" @click="closeRetain2CurrPage()">
      <div class="retain-popup-close" @click="closeRetain2CurrPage()"></div>
      <img src="../assets/images/sharepage-retain.png" alt="确认离开当前页面">
      <div class="retain-close" @click="callGoBack()"><!-- 我知道了 --></div>
    </van-popup>
    <!-- 未登录处理组件 -->
    <!-- <login-handle ref="loginHandle" /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import xes from '@xes/app-jssdk'
import rule from '../assets/js/rule.js'
import SharePanel from '../components/SharePanel'
import LoginHandle from '../components/LoginHandle'

const _emptyReward = [
  { dataNum: '--', dataUnit: '元', description: '现金' },
  { dataNum: '--', dataUnit: '元', description: '礼品卡' },
  { dataNum: '--', dataUnit: '个', description: '金币' },
  { dataNum: '--', dataUnit: '节', description: '兑换课程' }
]
export default {
  name: 'Home',
  components: { LoginHandle, SharePanel },
  computed: mapState(['userInfo', 'shareCountForGold']),
  data () {
    return {
      rule: rule, // 活动规则内容
      device: '', // 区分设备
      tutorId: '', // 辅导老师id
      pageNotice: '', // 页面（顶部）通告
      isShowRule: false, // 是否展示规则弹窗
      isShowSharePanel: false,
      rewardUnit: _emptyReward,
      isShowRetain2CurrPage: false, // 当前页面挽留弹窗
      isApp: /.*jzh$/.test(navigator.userAgent)
    }
  },
  watch: {
    isShowRule (val) {
      this.$xesLogger.clickMsg({
        params: {
          action: `showRulePopup-${val ? 'show' : 'close'}`,
          clickid: '5.3.21',
          status: val ? '1' : '0'
        }
      })
    },
    shareCountForGold (val) {
      if (val) {
        this.getPageData()
      }
    }
  },
  created () {
    const { tutorId } = this.$route.query
    this.tutorId = tutorId || ''
    const ua = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(ua)) { // 苹果设备
      this.device = 'iphone'
    } else if (/android/.test(ua)) { // 安卓设备
      this.device = 'android'
    } else { // web端
      this.device = 'web'
    }
  },
  mounted () {
    this.getPageData()
    this.getPageNotice()
    if (window.xesShare.shareClient === 2) {
      // app 内监注入左上角/底部 返回 监听函数
      this.registerGoBackListener()
      // 隐藏右上角菜单（...）功能
      xes.setTitleMenu(0) // de-bug
    }
  },
  methods: {
    // 控制底部分享面板
    handleSharePanelDisplay (isShow) {
      this.isShowSharePanel = isShow
    },
    // 分享成功回掉
    handleShareSucc (result) {
      console.log('handle share succ:', result)
    },
    // 分享失败, 调用登录，会刷新页面，重新设置分享数据
    handleShareErr (result) {
      console.log('handle share err:', result)
      this.$refs.loginHandle.callLogin()
    },
    // 分享点击
    handleShareClick (data) {
      console.log('handle Share Click', data)
    },
    // 奖励面板点击
    handleRewardClick (reward) {
      this.$xesLogger.clickMsg({ params: { action: 'handleRewardClick', clickid: '3.2.9', btn: reward.description } })
      if (reward.description === '礼品卡') return this.go2GiftCard()
      if (reward.description === '兑换课程') return this.go2CoureseExchange()
      this.go2RewardPage(reward.description)
    },
    go2GiftCard () {
      this.$xesLogger.clickMsg({ params: { action: 'go2GiftCard', clickid: '3.3.1' } })
      // 通过通知信息（跑马灯）接口判断登录，未登录跳转登录
      if (!this.userInfo) return this.$refs.loginHandle.callLogin()
      if (this.device === 'android' && this.isApp) {
        xesApp.start('http://app.xueersi.com/cardcouponh5/#/cardcoupon')
      } else {
        location.href = 'http://app.xueersi.com/cardcouponh5/#/cardcoupon'
      }
      console.log('挑战到礼品卡页面')
    },
    // 跳转课程兑换页面
    go2CoureseExchange () {
      this.$xesLogger.clickMsg({ params: { action: 'go2CoureseExchange', clickid: '3.2.2' } })
      // 通过通知信息（跑马灯）接口判断登录，未登录跳转登录
      if (!this.userInfo) return this.$refs.loginHandle.callLogin()
      this.$router.push({ name: 'courseExchange' })
    },
    // 跳转(我的)奖励详情页面
    go2RewardPage (btn) {
      this.$xesLogger.clickMsg({ params: { clickid: '5.3.9.0', action: 'go2RewardPage', btn } })
      let route = { name: 'rewardPage' }
      if (this.tutorId) {
        route = { name: 'rewardPage', query: { tutorId: this.tutorId } }
      }
      this.$router.push(route)
    },
    // 点击立即邀请，弹出分享弹层
    showSharePanel () {
      this.isShowSharePanel = true
      this.$xesLogger.clickMsg({ params: { action: 'showSharePanel', clickid: '3.2.8' } })
    },
    // 获取首页数据
    getPageData () {
      this.$api.getHomeData()
        .then(result => {
          const { code, data } = result
          if (code !== 0) return
          this.rewardUnit = data.userAward.dataBlock ? data.userAward.dataBlock : []
        })
    },
    // 获取页面公告
    getPageNotice () {
      this.$api.getmeginfo().then(res => {
        if (res.code !== 10001) {
          this.pageNotice = res.data.noticeMsg ? res.data.noticeMsg[0] : ''
        }
      })
    },
    // 当前页面/老带新挽留弹窗一个用户，当前设备只一次,未登录没有弹窗
    openRetain2CurrPage () {
      if (!this.userInfo) return false
      const retain2CurrPage_stat = localStorage.getItem(`retain2CurrPage_${this.userInfo.uid}`)
      if (retain2CurrPage_stat) return false
      this.isShowRetain2CurrPage = true
      localStorage.setItem(`retain2CurrPage_${this.userInfo.uid}`, 1)
      this.$xesLogger.clickMsg({ params: { action: 'openRetain2CurrPage', clickid: '5.3.20' } })
      return true
    },
    // 当前页面挽留弹窗-关闭
    closeRetain2CurrPage () {
      this.isShowRetain2CurrPage = false
      this.$xesLogger.clickMsg({ params: { action: 'closeRetain2CurrPage', clickid: '5.3.21' } })
    },
    // 退出/关闭当前页面,当前页面挽留弹窗-我知道了
    callGoBack () {
      xes.goBack()
      this.isShowRetain2CurrPage = false
      this.$xesLogger.clickMsg({ params: { action: 'callGoBack', clickid: '5.3.22' } })
    },
    // 原生app返回事件监听：直播间挽留弹窗。h5 页面的history 已经有一个监听了
    registerGoBackListener () {
      xes.setGoBackListener(() => {
        if (this.openRetain2CurrPage()) return
        xesApp.setGoBackListener(null)
        xes.goBack()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.invitation {
  min-height: 100vh;
  padding: 170px 0 70px;
  font-family: 'PingFang SC Regular', 'PingFang SC Regular-Regular';
  background: #e02727 url('../assets/images/home-title.png') no-repeat;
  background-size: 100%;

  &.invitation-notice {
    margin-top: 40px;
    // 活动规则按钮
    .invitation-btn-rule {
      top: 145px;
    }
  }

  .invitation-notice-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10; // 防止背景图片透视
  }
  // 活动规则按钮
  .invitation-btn-rule {
    position: absolute;
    top: 105px;
    right: 0;
    z-index: 20;
    width: 58px;
    height: 25px;// 被头图挡住了
  }
  // ## 奖励清单
  .invitation-reward-statement {
    position: relative;
    padding: 0 9px;
    font-size: 10px;
    font-weight: 400;

    .invitation-reward-sharecount {
      position: absolute;
      bottom: 42px;
      right: 29px;
      color: #ac7720;
    }

    output {
      color: #e02727;
    }
  }
  // ## 我的奖励
  .invitation-reward-myown {
    margin: 9px 9px;
    background: #fff;
    border-radius: 0 0 18px 18px;

    .invitation-card-title {
      padding: 10px 16px;
      font-size: 13px;
      text-align: left;

      .icon {
        top: 3px;
      }

      .icon-gift {
        background-image: url('../assets/images/gift.png');
      }

      b {
        font-weight: 600;
      }

      span {
        float: right;
        font-weight: 400;
        color: #f13f3f;
      }
    }

    .invitation-reward-myown-count {
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 10px 12px;
      // 内容项 content  item
      .invitation-reward-card-item {
        text-align: center;
        color: #666;
        // 奖励金币，学费 数字
        .invitation-reward-card-item-con {
          font-size: 12px;

          output {
            font-size: 21px;
            font-weight: 600;
            line-height: 27px;
            color: #f83f53;
          }
        }
        // 奖励描述信息
        .invitation-reward-card-item-des {
          font-size: 11px;
          font-weight: 300;
        }

        &.link {
          .invitation-reward-card-item-des {
            font-weight: 400;
            color: #207eff;
          }
        }
      }
    }
  }
  // ## 底部邀请按钮
  .invitation-btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    // padding: 14px 0;
    height: 70px;
    line-height: 70px;
    background: #d12121;

    & > img {
      width: 78%;
    }
  }
  // ## 底部邀请分享面板区
  .invitation-sharePanel {
    position: fixed;
    bottom: 0;
    z-index: 3;
    box-shadow: 0 -5px 14px 0 rgba(88, 19, 19, 0.1);
    transition: bottom 0.5s ease;
  }

  .invitation-sharePanel-hidden {
    position: fixed;
    bottom: -100%;
    z-index: 3;
    transition: bottom 0.5s ease;
  }

  .invitation-sharePanel-bg {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .rule-content-item {
    h5 {
      padding: 15px 0 10px;
      font-size: 14px;
      font-weight: 800;
      color: #ea152c;
    }

    p {
      margin-bottom: 10px;
      font-size: 11px;
      font-weight: 300;
      line-height: 18px;
      color: #a31e2c;

      i {
        font-weight: 400;
        color: #ea152c;
      }
    }
  }

  .invitation-popup {
    width: 320px;
    height: 60vh;
    min-height: 200px;
    padding: 0 27px;
    background: linear-gradient(#fffff7 24%, #fff6df 99%);
    border: 3px solid #fff;
    border-radius: 24px;
    box-shadow: 0 0 27px 0 rgba(231, 173, 83, 0.79) inset;

    &.van-popup {
      background-color: unset;
    }
    // 礼品卡说明弹窗
    &.giftcard-popup {
      height: 50vh;
    }

    .invitation-popup-close {
      position: absolute;
      top: 16px;
      right: 23px;
      width: 14px;
      height: 14px;
      background: url('../assets/images/tanchuang-close.png') no-repeat;
      background-size: 100%;
    }

    .invitation-popup-title {
      padding: 21px 0 11px;
      font-size: 24px;
      font-weight: 800;
      font-family: 'Lantinghei SC Heavy', 'Lantinghei SC Heavy-Heavy';
      line-height: 27px;
      color: #e02727;
      border-bottom: 1px dashed #cf6716;
      letter-spacing: 5px;
      text-shadow: 1px 0 0 #fff8ac;
    }

    .invitation-popup-content {
      position: absolute;
      top: 76px;
      bottom: 30px;
      left: 27px;
      right: 19px;
      overflow: auto;
      text-align: left;
    }
  }
  // 当前页面挽留弹窗
  .retain-popup {
    &.x-van-popup {
      background-color: transparent;
    }

    img {
      width: 255px;
    }

    .retain-popup-close {
      position: absolute;
      top: 8px;
      right: 0;
      width: 35px;
      height: 35px;
    }
    // 关闭当前页面（我知道了）
    .retain-close {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 180px;
      height: 40px;
      transform: translateX(-50%); // 图片右上角的关闭按钮比主图偏右
    }
  }
}
</style>
